import { getCookie, setCookie } from 'cookies-next';

import { TAppointmentHouseAddress } from 'types/appointment';

const CLIENT_COOKIE_NAME = 'ggClient';

type TClientCookie = {
  firstName: string;
  lastName: string;
  pronouns: string;
  email: string;
  phone: string;
  address?: TAppointmentHouseAddress;
};

export const getClientFromCookie = () => {
  let clientData: TClientCookie = {
    firstName: '',
    lastName: '',
    pronouns: '',
    email: '',
    phone: '',
  };

  try {
    const cookie = getCookie(CLIENT_COOKIE_NAME);

    if (typeof cookie === 'string') {
      clientData = JSON.parse(cookie);
    }
  } catch (e) {}

  return clientData;
};

export const setClientCookie = (client: TClientCookie) => {
  setCookie(CLIENT_COOKIE_NAME, client, {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  });
};
